import { Flex, Text } from "@pancakeswap/uikit"
import Image from "next/image"

 const Odos: React.FC = () => {
 return (
 <Flex justifyContent="center" alignItems="center" style={{ marginTop: 24 }} mb="1rem">
  <Text fontSize="12px" marginRight="6px">POWERED BY</Text>
  <Image
    src="/images/Odos1.png"
    alt="Powered by Odos" height="30px" width="85.56px" />
</Flex>
 )}

 export default Odos


